/**
 * @fileoverview PL-09 / WEB-620 — one search voice across the global nav.
 *
 * The header bar, SearchSheet, and city menu row all promise the same place.
 * Callers must pass a city **display name** (e.g. "Charlotte"), never a city
 * code (e.g. "CLT"). Empty / missing names yield a city-free stem so apex
 * (no-city) never renders "Search undefined…".
 */

/**
 * Human-facing search label without ellipsis — DialogTitle, aria-label, menu row.
 * @example formatSearchCityLabel('Charlotte') → 'Search Charlotte'
 * @example formatSearchCityLabel(undefined) → 'Search'
 */
export function formatSearchCityLabel(cityName: string | null | undefined): string {
  const name = typeof cityName === 'string' ? cityName.trim() : '';
  return name.length > 0 ? `Search ${name}` : 'Search';
}

/**
 * Input placeholder. Same words as the header label, with no ellipsis glyph.
 * @example formatSearchCityPlaceholder('Charlotte') → 'Search Charlotte'
 * @example formatSearchCityPlaceholder(null) → 'Search'
 */
export function formatSearchCityPlaceholder(cityName: string | null | undefined): string {
  return formatSearchCityLabel(cityName);
}
